<div class="mb-3" [class.has-error]="showError">
  <label *ngIf="props.label && props.hideLabel !== true" [attr.for]="id">
    {{ props.label }}
    <span *ngIf="props.required && props.hideRequiredMarker !== true">*</span>
  </label>

  <tui-editor
    [formControl]="formControl"
    [formlyAttributes]="field"
    [style.max-height.px]="maxHtmlContentLength"
  >
  </tui-editor>
  <small *ngIf="props.description" class="form-text text-muted">{{ props.description }}</small>
</div>
